import React, { useContext } from 'react';
import { ANALYTICS_ACTION_IMPRESSION } from '../../AnalyticsProvider';
import heroLarge from '../../assets/food-finder/hero-large.jpg';
import heroMedium from '../../assets/food-finder/hero-medium.jpg';
import heroSmall from '../../assets/food-finder/hero-small.jpg';
import AnalyticsContext from '../../context/AnalyticsContext';

const fpmFinderCategory = 'eec';

interface FoodWizardBannerProps {
  onClickCallback: () => void;
}

const FoodWizardBanner = ({ onClickCallback }: FoodWizardBannerProps) => {
  const { trackEvent } = useContext(AnalyticsContext);
  return (
    <div className="kib-container kib-container--full">
      <button
        data-testid="food-finder-get-started"
        className="launchpad"
        onClick={() => onClickCallback()}
      >
        <picture>
          <source media="(max-width: 639px)" srcSet={heroSmall} />
          <source media="(min-width: 640px) and (max-width: 1024px)" srcSet={heroMedium} />
          <source media="(min-width: 1025px)" srcSet={heroLarge} />
          <img
            data-testid="food-finder-get-started-image"
            onLoad={() =>
              trackEvent(fpmFinderCategory, ANALYTICS_ACTION_IMPRESSION, window.location.href)
            }
            src={heroMedium}
            alt="Get Started with our Fresh & Prepared Food Finder where you can get personalized recommendations, tailored to your pup’s needs."
          />
        </picture>
      </button>
    </div>
  );
};

export default FoodWizardBanner;
